import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import bankingLocationActions from '../actions/bankingLocation';
import payoutDetailsActions from '../actions/payoutDetails';

function getSupportedSites(store) {
    request.get(`/${config.url_prefix}/api/getSupportedSites`)
        .end((error, response) => {
            if (error) {
                store.dispatch(bankingLocationActions.alertError('ipmob.internal.server.error'));
            } else {
                try {

                    const res = JSON.parse(response.text);
                    const siteName = store.getState().system.siteName;
                    store.dispatch(bankingLocationActions.getSupportedSitesSuccess(siteName, res.supportedCountries, res.primarySiteMap));
                    // TODO: Remove once payout details page is connected to payments api to retrieve banking countries
                    store.dispatch(payoutDetailsActions.getBankingCountriesSuccess(siteName, res.supportedCountries, res.primarySiteMap));
                } catch (exp) {
                    store.dispatch(bankingLocationActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSupportedSites;
